import { action } from 'easy-peasy';
import { IActionSetTeamMemberDateValidation } from '../types';

const setTeamMemberDateValidation: IActionSetTeamMemberDateValidation = action((state, payload) => {
  state.teamMemberDateValidation = payload;
});

export default setTeamMemberDateValidation;
